export var WEEKLIST = ['周一', '周二', '周三', '周四', '周五', '周六', '周日'];
export var hospitalFormat = {
    establishTime: function (establishTime) {
        var numberEstablishTime = Number(establishTime);
        if (!numberEstablishTime) {
            return {
                showYearTag: false,
                diffYear: 0,
            };
        }
        var diffYear = new Date().getFullYear() - numberEstablishTime;
        return {
            showYearTag: diffYear >= 10,
            diffYear: diffYear,
        };
    },
    businessHours: function (businessHours) {
        var businessHour = (businessHours || [])[0];
        if (!businessHour) {
            return '';
        }
        var beginDay = businessHour.beginDay, endDay = businessHour.endDay, endTime = businessHour.endTime, beginTime = businessHour.beginTime;
        return WEEKLIST[beginDay - 1] + "\u81F3" + WEEKLIST[endDay - 1] + "  " + beginTime + "-" + endTime;
    },
};
